(function ($) {

//    if (window.TL === undefined) {
//        window.TL = {}
//    }

    if (TL.Signin === undefined) {
        TL.Signin = {};
    }

    //Inlnie Popup
    $(document).on('click', '.js-signin-popup', event => {
        event.preventDefault();

        var source = event.currentTarget.hash;
        $.magnificPopup.open({
            type: 'inline',
            items: {
                src: source
            },
            mainClass: 'component-popup mfp-slide-up',
            removalDelay: 200,
            modal: false
        });

        $('.js-signin-popup').addClass('onopen-announce-signup');
    });


    //Inlnie close popup
    $(document).on('click', '.mfp-close', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });


    var progress = {

        show() {

            //Sign in Button
            $('#userLoiginButton').prop('disabled', true);
            $('#userLoiginButton').addClass('btn-loading');

            //Sign up Button
            $('#userSignupButton').prop('disabled', true);
            $('#userSignupButton').addClass('btn-loading');

        },

        hide() {

            setTimeout(function () {

                //Sign in Button
                $('#userLoiginButton').prop('disabled', false);
                $('#userLoiginButton').removeClass('btn-loading');

                //Sign up Button
                $('#userSignupButton').prop('disabled', false);
                $('#userSignupButton').removeClass('btn-loading');
                
            }, 1000);
        },

        close() {

            setTimeout(function () {

                $('#popup-modal-dismiss').click();
            }, 500);
        },

        submitData(type, id, firstName, lastName, email) {
                                                     
            //Submit form
            var announce = $('#social-media-signin-form');
            if (announce) {
                $('#social-media-signin-form input[name="social-media-type"]').val(type);
                $('#social-media-signin-form input[name="social-media-id"]').val(id);
                $('#social-media-signin-form input[name="social-media-firstname"]').val(firstName);
                $('#social-media-signin-form input[name="social-media-lastname"]').val(lastName);
                $('#social-media-signin-form input[name="social-media-email"]').val(email);

                //Call remote command
                submitSocialMediaSigninInfoOnlyRemoteCommand();
            }

            var isOpenAnnounceSignup = $('.js-signin-popup').hasClass('onopen-announce-signup');
            if (isOpenAnnounceSignup) {

                submitSocialMediaSigninInfoAndUpdateAnnouncementWidgetFormRemoteCommand();

            } else {

                //Auto apply promo code                
                if (TL.Signin.accessCodePolicy === '2331') {
                    submitSocialMediaSigninInfoAndUpdateAnnouncementWidgetFormRemoteCommand();
                }
            }
        },
        
        facebookSubmitData(type, id, firstName, lastName, email) {

            //Submit form
            var announce = $('#social-media-signin-form');
            if (announce) {
                $('#social-media-signin-form input[name="social-media-type"]').val(type);
                $('#social-media-signin-form input[name="social-media-id"]').val(id);
                $('#social-media-signin-form input[name="social-media-firstname"]').val(firstName);
                $('#social-media-signin-form input[name="social-media-lastname"]').val(lastName);
                $('#social-media-signin-form input[name="social-media-email"]').val(email);

                //Call remote command
                submitFacebookSignResponseRemoteCommand();
            }

        }
    }

    if (TL.Signin.Progress === undefined) {
        TL.Signin.Progress = progress;
    }


    var applyAccessCode = function (displayTypeCode, isCleanupHighlightProduct) {

        //Top bar
        if (displayTypeCode === '2310') {


            setTimeout(function () {
                setTimeout(function () {
                    window.TL.Announce.topbar.hide('#popup_topbar', 400);
                }, 1800);
            }, 800);

            setTimeout(function () {
                setTimeout(function () {
                    applyPromotionFromAnnouncementTopBar(isCleanupHighlightProduct);
                }, 1900);
            }, 900);


        } else {

            setTimeout(function () {applyPromotionFromAnnouncementWidget(isCleanupHighlightProduct);}, 500);
        }

        setTimeout(function () {TL.Signin.Progress.close();}, 500);
    }

    if (TL.Signin.applyAccessCode === undefined) {
        TL.Signin.applyAccessCode = applyAccessCode;
    }


    var logout = function () {
        
        if (TL.Signin.Facebook !== undefined) {
            TL.Signin.Facebook.logout();
        }

        if (TL.Signin.Google !== undefined) {
            TL.Signin.Google.logout();
        }
        
        if (TL.Signin.Hotel !== undefined) {
            TL.Signin.Hotel.logout();
        }
        
        userSignOutRemoteCommand();        
           
        setTimeout(function () {location.reload();}, 500);        
    }

    if (TL.Signin.Logout === undefined) {
        TL.Signin.Logout = logout;
    }


    TL.Signin.setGuestSignInSuccess = function (firstName) {
        
        //Display user signed in        
        TL.Signin.onSigned(firstName);
    }
    
    
    TL.Signin.onSigned = function (firstName) {
        
    }

})(jQuery);

